<template>
  <div id="app">
<div class="grid">
<div class="wrapper">
    <div class="content">
      <router-view></router-view>
  </div>
    <div class="footer">
    <span>&copy; Susie Ward 2020</span>
    </div>
    </div>
      </div>
    </div>

</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

.grid {
display: grid;
width: 100vw;
height: 100vh;
justify-content: flex-start;
}


.wrapper {
display: grid;
grid-gap: 0px;
grid-template-areas:
                    "content content"
                    "footer footer";
}


.content {
grid-area: content;
display: grid;
justify-content: flex-start;


}

/* HEADER */

.header {
display: grid;
grid-area: header;
align-items: center;
grid-template-columns: auto auto;
padding-right: 45px;
padding-left: 45px;
padding-top: 10px;
padding-bottom: 10px;
margin-top: 0px;
width: 100vw;
}

.title {
display: grid;
    justify-content: flex-end;
font-family: 'Work Sans';
font-weight: 300;
font-size: 60px;
color: #F08080;
padding: 20px;
}

.contact {
display: grid;
justify-content: flex-start;
padding: 20px;
font-weight: 300;
}

@media screen and (max-width: 700px){

    .header {
padding-top: 25px;
padding-right: 25px;
padding-left: 25px;
padding-bottom: 5px;
}

    .title {
    font-size: 50px;
    }

    .contact {
    font-size: 16px;
    padding: 10px;
    padding-bottom: 0px;
    }

}

@media screen and (max-width: 400px){

    .header {
padding-top: 25px;
padding-right: 25px;
padding-left: 25px;
padding-bottom: 5px;
}

    .title {
    font-size: 40px;
    }

    .contact {
    font-size: 16px;
    padding: 10px;
    padding-bottom: 0px;
    }

}

</style>
